
import React, { useState, useEffect, useContext } from "react";


import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../../api/tmdbApi";
import moment from "moment";
import Modal from 'react-bootstrap/Modal';
import SweetAlert from 'react-bootstrap-sweetalert';
import * as Config from "../../constants/Config";
import Loader from "../../components/loader";
import { contentContext } from "../../context/contentContext";
import SessionPopup from "../../pages/SessionPopup"
import TableLoader from "../../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

let { lambda, appname } = window.app

const Notification = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { search } = state || {};
  const [toggle, setToggle] = useState(false);
  const [clientData, setClientData] = useState(null);
  // const [userdata, setUserData] = useState([]);
  const [errors, setErrors] = useState({});
  const [user, setUser] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    client: "",
    scheduleddate: "",
    logo: "",
    status: ""
  });
  const [fileError, setFileError] = useState("");
  const [filesData, setFilesData] = useState([])
  const [fileSizeError, setFileSizeError] = useState(false);
  const [files, setFiles] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertConfig, setAlertConfig] = useState({
    title: '',
    type: '',
    message: ''
  });
  const [isDelete, setIsDelete] = useState(false)
  const [btnLoader, setBtnLoader] = useState(false)
  const [deleteLoader, setDeleteLoader] = useState(false)

  // const [perpage, setPerpage] = useState(10);
  // const [arrow, setArrow] = useState(0);
  const [perpage, setPerpage] = useState(10);
  const [image, setImg] = useState("");
  // const [currentPage, setcurrentPage] = useState(1);
  const [itemsPerPage, setitemsPerPage] = useState(10);

  const [pageNumberLimit, setpageNumberLimit] = useState(5);
  const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
  const [showSessionPopupup, setShowSessionPopupup] = useState(false);
  const [tableErrMsg, setTableErrMsg] = useState(false);
  const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
  const [notificationid, setnotificationid] = useState("")
  const [toastType, setToastType] = useState("")
  const [arrowdir, setArrowDir] = useState('down');
  const [num, setNum] = useState();
  // const [sortDirection, setSortDirection] = useState('asc');


  const loginType = localStorage.getItem('login_type'); // 'admin' or 'client'
  // console.log('loginType',loginType,localStorage.getItem("clientid"));
  const useruniqueid = localStorage.getItem("userId")

  // let id = localStorage.getItem("userId");

  const [flag, setFlag] = useState(false);

  // const [isLoading, setIsLoading] = useState(false); 
  const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, userData, setUserData, GetClientDataContext, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
  const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Notifications")
  const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
  console.log('validate obj', userData.permissions)


  const prevRoute = usePrevious(route)
  useEffect(() => {
    if (prevRoute !== undefined && prevRoute != route) {
      setCurrentPage(1)
      setRowsPerPage(15)
      setSearchedFlag(false);
      setUserSearch("")
    }
  }, [prevRoute]);
  //  console.log('prevRoute--->',prevRoute)
  //  console.log('currentRoute--->',route)
  useEffect(() => {
    getNotifications();
    getClients();
  }, [])
  useEffect(() => {
    if (toastMessage && toastType && toast[toastType]) {
      toast[toastType](toastMessage, {
        position: "bottom-center",
        // autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      // Clear the message after showing to prevent re-triggering
      setToastMessage && setToastMessage("");
    }
  }, [toastMessage, toastType]);

  useEffect(() => {

    if (window.site === undefined) {
      setTimeout(() => {
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
          setImg(window.site.common.imageCloudfront)
        }
      }, 1000);
    }
    if (window.site && window.site.common && window.site.common.imageCloudfront) {
      setImg(window.site.common.imageCloudfront)
    }


  }, [window.site]);

  const handleEdit =  (data) => {
    setFormData(data)
setErrors({})
  }



  const keyForRerender = `${rowsPerPage}_${data?.length}`;
  const columns = [

    {
      name: 'TITLE',
      selector: row => row?.title ?? "",
      sortable: true,
    },
    {
  name: 'Scheduled date',
 selector: row => row?.scheduleddate 
        ? row.scheduleddate.split('-').reverse().join('/') 
        : '',
  sortable: true,
},


    {
      name: 'Status',
      selector: row => row?.status ?? "",
      sortable: true,
    },

    {
      name:
        <>
          {(subValDashboard && subValDashboard.delete && subValDashboard.delete.display === true) || (subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true) ?
            'Actions' : null}</>
      // 'Actions'
      ,
      cell: (props) =>
        //  {
        subValDashboard && subValDashboard.delete && subValDashboard.edit && (subValDashboard.delete.display === true || subValDashboard.edit.display === true) &&
        <div className="d-flex">
          {( subValDashboard?.edit?.display === true && props?.status !=="COMPLETED") &&
            <a
              className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false  ? 'pe-none' : ''} text-success action-button`}
              onClick={() => handleEdit(props)}
            //  className={` text-success action-button`}
            id="notification-edit-button"><i className="mdi mdi-pencil font-size-18"></i></a>
          }
          {subValDashboard && subValDashboard.delete && subValDashboard.delete.display === true &&
            <a style={{ position: "inherit" }} onClick={() => handleDelete(props?.notificationid)}
              className={`${subValDashboard && subValDashboard.delete && subValDashboard.delete.enable === false ? 'pe-none' : ''} text-danger action-button`}
            // className={`text-danger action-button`}
            id="notification-delete-button"><i className="mdi mdi-delete font-size-18"></i></a>
          }
        </div>
      //  }
      ,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },

  ];
  const handleDelete = (id) => {
    setIsDelete(true)
    setnotificationid(id)
  }
  const handlePageChange = (page) => {
    GetTimeActivity()
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage) => {
    GetTimeActivity()
    setRowsPerPage(newPerPage);
  };

  // console.log('datattatatattatat',data)
  useEffect(() => {
    setRoute("user")
    //  GetClientDataContext()
    setActiveMenuId(200005)
    setActiveMenuObj({
      "Client Management": false,
      "Contact Management": false,
      "Reports": false
    })
    userActivity();
  }, []);
  const userActivity = () => {
    let path = window.location.pathname.split("/");
    const pageName = path[path.length - 1];
    var presentTime = moment();
    let payload;

    payload = {
      "userid": localStorage.getItem("userId"),
      "pagename": pageName,
      "pageurl": window.location.href,
      "starttime": presentTime,
      "useragent": JSON.parse(localStorage.getItem("loc"))

    };


    const previousId = localStorage.getItem("previousid");
    const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


    axios({
      method: 'POST',
      url: urlLink,
      data: payload
    })
      .then(function (response) {
        if (response?.data?.statusCode === 200) {
          localStorage.setItem("previousid", response?.data?.result)
        }
      });
  }
  const GetUserData = async () => {
    GetTimeActivity()
    try {

      const response = await tmdbApi.getUserData({});

      if (response?.statusCode === 200) {

        setUserData(response?.result?.[0]);
        localStorage.setItem("ClientName", response?.result?.[0]?.name)
        localStorage.setItem("ClientType", response?.result?.[0]?.type)
        let userArr = response?.result?.[0]?.permissions

        const obj = userArr.reduce((acc, item) => {
          if (item.submenus) acc[item.menu] = false;
          return acc;
        }, {});
        // console.log('objjjjjjjj--->',obj)
        // setActiveMenuObj(obj)

        console.log('response?.result?.[0]', response?.result?.[0])
      }
    } catch {
      console.log("error");
    }
  };


  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/");
    }

  }, []);

  //  useEffect(() => {


  //      console.log("trueeeeeeeeee",searchedFlag);
  //      if (searchedFlag) { 
  //          console.log("came") 
  //          handleSearch();
  //      } else {
  //          console.log("called get all deals") 
  //          User();
  //      }

  //  }, [searchedFlag]);

  const PageLoad = (e) => {
    const pagevalue = e.target.value;
    //setPerpage(pagevalue);
    setitemsPerPage(pagevalue);
    setcurrentPage(1);
    setmaxPageNumberLimit(5);
    setminPageNumberLimit(0);

  }


  const User = (e) => {
    GetTimeActivity()
    setIsLoading(true)
    const token = localStorage.getItem("token")
    axios({
      method: 'GET',
      url: lambda + '/users?appname=' + appname + "&token=" + token,
    })
      .then(function (response) {
        console.log("response", response);
        if (response?.data?.result === "Invalid token or Expired") {
          setShowSessionPopupup(true)
        } else {
          setUser(response?.data?.result);
          setData(response?.data?.result?.data);
          global.exportExcelData = response?.data?.result?.data



          setIsLoading(false);
          setUserSearch("");
          setSearchedFlag(false);
        }
      }).catch((err) => {
        console.log('error', err);
        setTableErrMsg(true)
        setIsLoading(false);
      });
  }





  const handleSearch = (e, flagggg) => {
    GetTimeActivity()
    if (flagggg) {
      setcurrentPage(1);
    }
    setmaxPageNumberLimit(5);
    setminPageNumberLimit(0);
    if (flagggg === "normalsearch") {
      setSearchedFlag(true)
    }
    setFlag(true)
    if (usersearch === "") {
      User();
    }
    else {
      setIsLoading(true)
      const token = localStorage.getItem("token")
      axios({
        method: 'GET',
        url: lambda + '/users?appname=' + appname + "&search=" + usersearch + "&token=" + token,
      })
        .then(function (response) {
          if (response?.data?.result === "Invalid token or Expired") {
            setShowSessionPopupup(true)
          } else {
            console.log("response", response);
            setUser(response?.data?.result);
            setData(response?.data?.result?.data);
            global.exportExcelData = response?.data?.result?.data



            setIsLoading(false)
          }
        }).catch((err) => {
          console.log('error', err);
          setTableErrMsg(true)
          setIsLoading(false);
        });
    }
  }

  const validateForm = () => {
    console.log("Validating Form...");

    let tempErrors = {};
    let isValid = true;

    if (!formData.description || formData.description.trim() === "") {
      tempErrors.description = "description is required";
      isValid = false;
    }
    if (!formData.title || formData.title.trim() === "") {
      tempErrors.title = " name is required";
      isValid = false;
    }
    console.log(formData.scheduleddate, "ammu")
    if (!formData.scheduleddate || formData.scheduleddate.trim() === "") {
      tempErrors.scheduleddate = " schedule date is required";
      isValid = false;
    }

    // if (!formData.status) {
    //   tempErrors.status = "status is required";  // Fixed typo
    //   isValid = false;
    // }

    // if (!formData.logo || formData.logo.trim() === "") {
    //     tempErrors.logo = "Icon is required";
    //     isValid = false;
    // }

    setErrors(tempErrors);  // Update state with errors

    return isValid;  // Return validation result
  };




  const handleFileChange = (event) => {
    setErrors({ ...errors, logo: "" })
    const selectedFile = event.target.files[0];

    if (!selectedFile) return; // Prevents error if no file is selected

    const allowedType = "image/svg+xml"; // Allow only SVG files
    let fileSize = 1048612 * 1; // 5MB

    if (selectedFile.type !== allowedType) {
      // setFileError("Only SVG images are allowed.");
      setToastMessage("Only SVG images are allowed.")
      setToastType("error")
      // setFileSizeError(true);
      return;
    }

    if (selectedFile.size < fileSize) {
      const previewUrl = URL.createObjectURL(selectedFile);
      setFormData({ ...formData, logo: previewUrl }); // Store preview URL
      setFilesData([selectedFile]); // Store file data

    } else {
      setFileError("File size greater than 1MB.");
      setFileSizeError(true);
      event.target.value = null;

    }
  };
  const handleUploadSubmit = async () => {

    const ObjectID = require("bson-objectid");
    const uniqueId = new ObjectID().toString();
    // setLocationId(locationId)
    const validate = validateForm()
    if (validate) {
      setBtnLoader(true)
      if (filesData && filesData?.length > 0) {

        const uploadPromises = Array.from(filesData).map(async (file) => {
          const timestamp = Date.now();
          const fileExtension = file?.name?.split('.').pop();
          const clientid = localStorage.getItem('userId');
          const token = localStorage.getItem('token');
          const ObjectID = require("bson-objectid");

          const uniqueId = new ObjectID().toString();
          let uploadFilePath;
          let bucket;

          // Check the file type
          if (file.type.startsWith('image/')) {
            // File is an image
            let filenameReplace = file.name.replace(/ /g, "_")
            uploadFilePath = `${appname}/${uniqueId}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
            bucket = window?.site?.common?.resourceBucket; // Use resource bucket for images
            const data = {
              source_bucket: bucket, // Use the correct bucket based on file type
              sourcepath: uploadFilePath
            };
            console.log("data", data)
            const newFile = [{
              filename: filenameReplace.split('.')[0],
              filepath: uploadFilePath,
              fileid: uniqueId,
              filetype: file.type,
              filesize: file.size,
              fileformat: fileExtension
            }]
            const updatedFiles = newFile;
            console.log("updatedFiles", updatedFiles)
            setFiles(updatedFiles);

            const uploadPromise = axios.post(
              `${lambda}/uploadURL?appname=${appname}`,
              data,
              { headers: { 'Content-Type': 'application/json' } }
            ).then(async uploadUrlResponse => {
              if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                const url = uploadUrlResponse.data.result;

                return axios.put(url, file, {
                  headers: {
                    'Content-Type': file.type,
                    'Cache-Control': 'no-cache'
                  }
                }).then(async uploadResponse => {
                  if (uploadResponse.status === 200) {
                    // setFiles([...files, ...newFile]); 
                    // handleSubmit(updatedFiles);
                    handleCreate(updatedFiles)
                  } else {
                    throw new Error('Failed to upload file to S3');
                  }
                });
              } else {
                throw new Error('Failed to get upload URL');
              }
            });


          }


        });

        try {
          //const results = await Promise.all(uploadPromises);
          await Promise.all(uploadPromises);

        } catch (error) {
          console.error('Error during file upload:', error);
        }
      } else {
        // handleSubmit([], uniqueId);

        handleCreate([], uniqueId);

      }
    }


  }
  const handleCreate = async (filesData) => {

    let siteConfig = window?.site?.common;
    console.log("siteConfig", siteConfig);

    let appResourcesUrl = siteConfig?.imageCloudfront;
    let logoImage = ""; // Declare logoImage outside the if block
    console.log("filesDataaaaaaaa", filesData)
    if (filesData && filesData.length > 0) {
      logoImage = filesData?.[0]?.filepath; // Update the value of logoImage
    }

    console.log("logoImage", logoImage);

    try {
      console.log("form1212122", formData);
 const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const payload = {
       
        createdBy: {
          name: userData?.name,
          userid: localStorage.getItem("userId"),
        },
        description: formData?.description,
        title: formData?.title,
        scheduleddate: formData?.scheduleddate,
        client:formData?.client,
        logo: filesData?.length > 0 ? logoImage : formData?.logo,
          timezone: timeZone,
        // status: formData?.status,
      };

      if (formData?.notificationid) {
        try {
          const response = await axios.post(
            `${lambda}editnotification?appname=${appname}&userid=${localStorage.getItem("userId")}&notificationid=${formData?.notificationid}`,
           {...payload,
            "read":false} 
          );

          console.log("response", response);
          if (response?.data?.result === "Notification name already exists") {
            setToastMessage("Notification name already exists.");
            setToastType("warning");
            setIsLoading(false);
            setBtnLoader(false);
          } else
            if (response?.data?.result === "updated successfully") {
              setToastMessage("Notification Updated Successfully");
              setToastType("success");
              setFilesData([])
              setFormData({ name: "", status: "", logo: "", notificationid: "",client:"",scheduleddate:"" });
              setTimeout(() => {
                getNotifications();
              }, 2000);
            }
        } catch (error) {
          console.error("Error updating notification:", error);
          setToastMessage("Failed to update notification");
          setToastType("error");
        } finally {
          setBtnLoader(false);
        }
      } else {
        console.log("payload", payload);
        try {
          const token = localStorage.getItem("token");
          const response = await axios.post(
            `${lambda}notifications?appname=${appname}&token=${token}`,
            payload
          );

          if (response?.data?.result === "Notification name already exists") {
            setToastMessage("Notification name already exists.");
            setToastType("warning");
            setIsLoading(false);
            setBtnLoader(false);
          } else {
            console.log("response:", response);
            setIsLoading(false);
            setToastMessage("Notification Created Successfully");
            setToastType("success");
            setFilesData([])
            setFormData({ name: "", status: "", logo: "", notificationid: "",client:"",scheduleddate:"" });
            setTimeout(() => {
              getNotifications();
            }, 2000);

            setBtnLoader(false);
          }
        } catch (error) {
          console.error("Error while adding notification:", error);
          setIsLoading(false);
        }
      }
    } catch (error) {
      setAlertConfig({
        title: "Error",
        type: "error",
        message: error.response?.data?.message || "Something went wrong",
      });
      setShowAlert(true);
    }
  };


  const handleDeleteNotification = async () => {
    setDeleteLoader(true)
    try {
      //   console.log("formData before deletion:", formData);

      const payload = {
        // archivedBy: {
        //   name: userData?.name, 
        //   userid: useruniqueid
        // },
        status: "ARCHIVE",
        // archivedOn: new Date().toISOString(),
        // logo: filesData?.length > 0 ? logoImage : formData?.logo,

      };


      const response = await axios.post(
        `${lambda}deletenotification?appname=${appname}&userid=${useruniqueid}&notificationid=${notificationid}`,
        payload
      );

      console.log("API Response:", response);

      setDeleteLoader(false)
      setToastMessage(" Notification Deleted Successfully");
      setToastType("success");
      setIsDelete(false)
      // Reset form after update
      setFormData({ name: "", status: "", logo: "", notificationid: "" });

      setTimeout(() => {
        getNotifications(); // Fetch updated notification list
      }, 2000); // Ensure toast is visible before refresh


    } catch (error) {
      console.error("Error updating notification:", error);
      setToastMessage("Failed to update notification");
      setToastType("error");
    } finally {
      setBtnLoader(false);
    }
  };


  const getClients = async () => {
    // setIsLoading(true)
    try {
      const token = localStorage.getItem("token");
      const urlLink = `${lambda}/clients?appname=${appname}&userid=${localStorage.getItem("userId")}`;

      axios({
        method: 'POST',
        url: urlLink,
        // data: payload,
        // data: result,
      })
        .then(function (response) {
          if (response?.data?.result === "Invalid token or Expired") {
            setShowSessionPopupup(true);
            setIsLoading(false)
          } else {
            const result = response?.data?.result?.data
              ?.filter(item => item.contactname)
              .map(({ clientid, contactname }) => ({ clientid, contactname }))
              .sort((a, b) => a.contactname.localeCompare(b.contactname));
            setClientData(result);
            // setIsLoading(false)
          }
        })
        .catch()




    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };
  const getNotifications = async () => {
    setIsLoading(true)
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${lambda}getNotifications?appname=${appname}&token=${token}`);

      if (response?.data?.result === "Invalid token or Expired") {
        setShowSessionPopupup(true);
        setIsLoading(false)
      } else {
        setData(response?.data?.result);
        setIsLoading(false)
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };
  console.log("errorsssssssssssssssssssssssssss", errors)
  const handleRemove = () => {
    setFilesData([])
    setFormData({ ...formData, logo: "" })
  }
  const handleChange = (event) => {

    const { name, value } = event.target;

    if (name === "title") {
      // Validate phone number: only numbers and a maximum of 10 digits
      setFormData((prevData) => ({
        ...prevData, // Keep the other fields intact
        [name]: value, // Update the phone number field
      }));

      setErrors({ ...errors, title: "" })

    } else if (name === "description") {
      // Validate phone number: only numbers and a maximum of 10 digits
      setFormData((prevData) => ({
        ...prevData, // Keep the other fields intact
        [name]: value, // Update the phone number field
      }));

      setErrors({ ...errors, description: "" })

    }
    else if (name === "scheduleddate") {
      // Validate phone number: only numbers and a maximum of 10 digits
      setFormData((prevData) => ({
        ...prevData, // Keep the other fields intact
        [name]: value, // Update the phone number field
      }));

      setErrors({ ...errors, scheduleddate: "" })

    }
    else if (name === "status") {
      // Validate phone number: only numbers and a maximum of 10 digits
      setFormData((prevData) => ({
        ...prevData, // Keep the other fields intact
        [name]: value, // Update the phone number field
      }));

      setErrors({ ...errors, status: "" })

    } else {
      // Allow normal updates for other fields
      setFormData((prevData) => ({
        ...prevData, // Keep the other fields intact
        [name]: value, // Update the changed field
      }));
    }
  };


  console.log("formData-------------------------->", formData)
  //  const handleKeypress = (e) => {
  //      //it triggers by pressing the enter key
  //      GetTimeActivity()   
  //      if ((e.key === "Enter")) {
  //          setTimeout(function () {
  //              handleSearch();
  //          }, 1000);
  //      }
  //  };
  const handleAddUser = (e) => {
    GetTimeActivity()
    navigate("/adduser");
  }
  const handleClose = () => {
    setIsDelete(false)
  }
  const handleEditUser = (e, paramuserid) => {
    console.log('paramuserid', paramuserid)
    GetTimeActivity()
    navigate("/edituser/" + paramuserid);
  }
  const handleViewUser = (e, paramuserid) => {
    GetTimeActivity()
    console.log('paramuserid', paramuserid)

    navigate("/viewuser/" + paramuserid);
  }

  const clearSearch = () => {
    GetTimeActivity()
    setUserSearch("");
    User();
    setcurrentPage(1);
  }

  const customNoRecords = () => {
    return (

      <div className="empty-state-body empty-record"  >
        <div className="empty-state__message">
          <span className="material-icons">summarize</span>
          <p className="form-check font-size-16">No notifications</p>
        </div> </div>
    )
  }
  const handleExport = () => {

    // let k = defaultData || exportExcelData
    const modifiedArray = global.exportExcelData.map((each, i) => ({
      "S.NO": i + 1,
      "NAME": each?.name ?? "",
      "USER TYPE": each?.type ?? "",
      "EMAIL ID": typeof each?.emailid === "object" && each?.emailid !== null && each?.emailid.length > 1 ? each?.emailid.join(', ') : each?.emailid ?? "",
      "PHONE NUMBER": each?.phone ?? "",
      "STATUS": each?.status ?? "",

    }));

    exportToExcel(modifiedArray, "data");

  }
  function exportToExcel(jsonData, fileName) {
    delete jsonData['_id'];
    const worksheet = XLSX.utils.json_to_sheet(jsonData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data1 = new Blob([excelBuffer], { type: 'application/octet-stream' });
    //FileSaver.saveAs(data, `${fileName}.xlsx`);
    FileSaver.saveAs(data1, `UsersData.xlsx`);
    console.log('data22222--->', data)
  }
  const customSort = (rows, selector, direction) => {
    const sortedData = rows.slice().sort((rowA, rowB) => {
      // use the selector function to resolve your field names by passing the sort comparators
      // const aField = selector(rowA);
      const aField = String(selector(rowA)).toLowerCase();

      //  const bField = selector(rowB);
      const bField = String(selector(rowB)).toLowerCase();

      let comparison = 0;

      if (aField > bField) {
        comparison = 1;
      } else if (aField < bField) {
        comparison = -1;
      }

      return direction === 'desc' ? comparison * -1 : comparison;
    });

    // Log the sorted data to the console
    // setSortedRecomData(sortedData)
    global.exportExcelData = sortedData
    // console.log('Sorted Data------>:', sortedData);

    return sortedData;
  };
  // console.log("showSessionPopupup",showSessionPopupup)
  return (
    <>
      {showSessionPopupup && <SessionPopup />}
      <div id="layout-wrapper">
        <Header />
        <Sidebar />

        {/* Start right Content here  */}
        {isLoading ? <Loader /> :
          <div id="userManagement" className="main-content user-management notifications-page">
            <div id="pageContent" className="page-content">
              <div id="containerFluid" className="container-fluid">
                <div id="breadcrumbRow" className="row breadcrumb">
                  <div id="breadcrumbCol" className="col-lg-12">
                    <div id="breadcrumbWrapper" className="d-flex align-items-center">
                      <div id="breadcrumbContent" className="flex-grow-1">
                        <h4 id="notificationManagementTitle" className="mb-2 card-title">NOTIFICATION MANAGEMENT</h4>
                        <p id="menuPath" className="menu-path">
                          <span>Spot Management</span> / <b>ADD NOTIFICATION</b>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div id="tableDataRow" className="row table-data">
                  <div id="tableDataCol" className="col-12">
                    <div id="notificationCard" className="card">
                      <div id="notificationCardBody" className="card-body">
                        <div id="addnotificationRow" className="row add-notification-page-style">
                          <div id="addnotificationCol" className="col-md-3 pe-1">
                            <div id="basicPlanLeft" className="basic_plan">
                              <h4 id="addnotificationTitle" className="form-title">ADD NOTIFICATION</h4>

                              <label id="notificationNameLabel" className="form_label mt-2 span-style">TITLE<span className="required">*</span></label>
                              <div id="titleInputGroup" className="input-group mb-4 mr-sm-2 error-mssg-style">

                                <input id="titleInput" className="form-control border-style" placeholder="Title" type="text" name="title" value={formData?.title} onChange={handleChange} />
                                {errors && <span id="notificationNameError" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{errors?.title}</span>}
                              </div>




                              <label id="notificationDescriptionLabel" className="form_label mt-2 span-style">DESCRIPTION<span className="required">*</span></label>

                              <div id="notificationdescInput" className="input-group mb-4 mr-sm-2 error-mssg-style">

                                <textarea id="notificationdescInputGroup" className="form-control border-style" placeholder="Description" type="text" name="description" value={formData?.description} onChange={handleChange}></textarea>
                                {errors && <span id="notificationNameError" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{errors?.description}</span>}
                              </div>
                              <label id="statusLabel" className="form_label mt-3 span-style">Client</label>
                              <div id="statusInputGroup" className="input-group mb-2 mr-sm-2 error-mssg-style">
                                <select id="clientSelect" className="form-select select-style border-style" name="client" value={formData?.client} onChange={handleChange}>
                                  <option>ALL</option>
                                  {
                                    clientData && clientData.map(client => client.contactname && <option value={client.clientid}>{client.contactname}</option>)
                                  }
                                </select>
                                {errors && <span id="statusError" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{errors?.clinet}</span>}
                              </div>

                              <label id="notificationdateLabel" className="form_label mt-2 span-style">Schedule date<span className="required">*</span></label>
                              <div id="titleInputGroup" className="input-group mb-4 mr-sm-2 error-mssg-style">

                                <input className="form-control border-style" placeholder="Enter date" type="date" name="scheduleddate" onChange={handleChange} min={new Date().toISOString().split('T')[0]} value={formData?.scheduleddate} id="notificationscheduleddate"/>
                                {errors && <span id="notificationdateError" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{errors?.scheduleddate}</span>}
                              </div>
                              <label id="uploadIconLabel" className="form_label  span-style">UPLOAD IMAGE(OPTIONAL)</label>
                              {formData?.logo?.length > 0 ? (
                                <div id="uploadIconPreview" className="upload-icon">
                                  <div id="uploadIconBlock" className="img_block add_img_block">
                                    <span id="removeIconBtn" className="material-icons-outlined thumbnail-cls-icon" onClick={handleRemove}>close</span>
                                    {formData?.logo?.startsWith("blob:") ? <img id="activeImg" src={formData?.logo} width={150} /> : <img id="activeImg" src={` ${image}${formData?.logo}`} width={150} />}
                                  </div>
                                </div>
                              ) : (
                                <div>
                                  <input type="file" accept="image/*" className="d-none" id="uploadIcon" onChange={handleFileChange} />
                                  <label htmlFor="uploadIcon" id="uploadIconBtn" className="stroke-button logo-width">
                                    <span className="material-icons">file_upload</span>
                                  </label>
                                  {/* {errors && <span id="uploadIconError" className="errormsg" style={{ fontWeight: 'bold', color: 'red',marginLeft: "5px" }}>{errors?.logo}</span>} */}
                                </div>
                              )}

                              {/* <label id="statusLabel" className="form_label mt-3 span-style">Status<span className="required">*</span></label>
                              <div id="statusInputGroup" className="input-group mb-2 mr-sm-2 error-mssg-style">
                                <select id="statusSelect" className="form-select select-style border-style" name="status" value={formData?.status} onChange={handleChange}>
                                  <option value="">Status</option>
                                  <option value="ACTIVE">ACTIVE</option>
                                  <option value="INACTIVE">IN ACTIVE</option>
                                  {formData?.status==="COMPLETED" &&  <option value="COMPLETED">COMPLETED</option>}
                                 
                                </select>
                                {errors && <span id="statusError" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{errors?.status}</span>}
                              </div> */}
                              {subValDashboard && subValDashboard.Add && subValDashboard.Add.display === true && <button id="savenotificationBtn" className={subValDashboard && subValDashboard.Add && subValDashboard.Add.enable === true ? "fill-btn save_continue mt-4 float-none" : "fill-btn save_continue mt-4 float-none pe-none"} onClick={handleUploadSubmit} disabled={btnLoader}>
                                {btnLoader && <img id="loadingIcon" src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" alt="Loading" />}
                                {formData?.notificationid ? "Update" : "Publish"}
                              </button>}

                            </div>
                          </div>

                          <div id="notificationsCol" className="col-md-9 ps-1">
                            <div id="basicPlanRight" className="basic_plan">
                              <h4 id="notificationsTitle" className="form-title">NOTIFICATION HISTORY</h4>
                              <DataTable
                                id="notificationsTable"
                                key={keyForRerender}
                                columns={columns}
                                keyField="_id"
                                data={data}
                                direction="auto"
                                highlightOnHover
                                fixedHeaderScrollHeight="300px"
                                pagination
                                responsive
                                persistTableHead
                                striped
                                defaultSortField="name"
                                noDataComponent={customNoRecords()}
                                paginationTotalRows={data?.length}
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                paginationPerPage={rowsPerPage}
                                paginationDefaultPage={currentPageNew}
                                paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                paginationComponentOptions={{
                                  rowsPerPageText: 'Per page:',
                                  rangeSeparatorText: 'of',
                                  noRowsPerPage: false,
                                  selectAllRowsItem: false,
                                  selectAllRowsItemText: 'All',
                                }}
                                progressPending={isLoading}
                                progressComponent={<TableLoader />}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        
            <Modal className="new-set-modal" show={isDelete}>
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content rounded-4">

      {/* Modal Header */}
      <div className="modal-header border-0 justify-content-center position-relative" id="notification-delete-header">
        <button
          className="close-btn"
          onClick={e => handleClose()}
          id="notification-delete-close-btn"
        >
          <span className="material-icons">close</span>
        </button>
      </div>

      {/* Modal Body */}
      <div className="modal-body text-center" id="notification-delete-body">
        <img
          src={`${image}${appname}/images/web/disco-ball.gif`}
          alt="Delete Icon"
          className=""
          style={{ width: "100px", height: "100px" }}
          id="notification-delete-icon"
        />
        <h3 className="modal-sm-heading" id="notification-delete-title">Delete</h3>
        <p className="modal-text" id="notification-delete-text">
          The changes cannot be undone.<br />
          Do you want to delete?
        </p>
      </div>

      {/* Modal Footer */}
      <div className="modal-footer border-0 justify-content-center gap-3 pb-4" id="notification-delete-footer">
        <button
          className="stroke-btn-style"
          onClick={() => setIsDelete(false)}
          id="notification-dont-delete-btn"
        >
          Don’t Delete
        </button>
        <button
          className="fill-btn save_continue"
          onClick={handleDeleteNotification}
          id="notification-confirm-delete-btn"
        >
          {deleteLoader ? (
            <img
              src={`${image}${appname}/images/web/rotate_right.svg`}
              className="loading-icon"
              alt="Loading"
              id="notification-delete-loader"
            />
          ) : null}
          Yes
        </button>
      </div>

    </div>
  </div>
</Modal>

            <SweetAlert
              id="tableErrorAlert"
              show={tableErrMsg}
              custom
              confirmBtnText="OK"
              confirmBtnBsStyle="primary"
              title={"Something went wrong. Please reload again."}
              onConfirm={() => setTableErrMsg(false)}
            />

            <SweetAlert
              id="fileSizeErrorAlert"
              show={fileSizeError}
              warning
              confirmBtnText="OK"
              confirmBtnBsStyle="danger"
              title={fileError}
              onConfirm={() => setFileSizeError(false)}
            />

            <SweetAlert
              id="genericAlert"
              show={showAlert}
              title={alertConfig.title}
              type={alertConfig.type}
              onConfirm={() => setShowAlert(false)}
            >
              {alertConfig.message}
            </SweetAlert>

            <Footer id="footerComponent" />

            <ToastContainer
              id="toastContainer"
              position="bottom-center"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover={false}
              theme="light"
            />
          </div>
        }




      </div>
    </>
  );
};

export default Notification;
